export default "__VITE_ASSET__CVsgpxGR__"